export const stateKeys = {
  selectedRowKeys: 'selectedRowKeys',
  expandedRowKeys: 'expandedRowKeys',
  filterInfo: 'filterInfo',
  sortInfo: 'sortInfo',
  page: 'page',
  pageSize: 'pageSize',
  totalItems: 'totalItems',
  preparedDataIdsSet: 'preparedDataIdsSet',
};

export const tableId = 'dspx-table';
